import ActiveSideBarIcon from "../src/assets/images/svg/header/dashboard-fill-svgrepo-com.svg";
import InactiveSideBarIcon from "../src/assets/images/svg/header/dashboard-svgrepo-com.svg";

export default {
  superItems: [
    // {
    //   id: "Dashboard",
    //   title: "Dashboard",
    //   type: "group",
    //   url: "/dashboard",
    //   isIcon: true,
    //   inactive_icon: InactiveSideBarIcon,
    //   active_icon: ActiveSideBarIcon,
    //   isChildren: false,
    //   // routerKey: 'DASHBOARD',
    // },
    {
      id: "AppBanners",
      title: "App Banners",
      type: "group",
      url: "/app-banners",
      isIcon: true,
      inactive_icon: InactiveSideBarIcon,
      active_icon: ActiveSideBarIcon,
      isChildren: false,
      // routerKey: 'APPBANNER',
    },
    {
      id: "Masters",
      title: "Masters",
      type: "group",
      isIcon: true,
      inactive_icon: InactiveSideBarIcon,
      active_icon: ActiveSideBarIcon,
      isChildren: true,
      children: [
        {
          id: "Areas",
          title: "Areas",
          type: "item",
          url: "/areas-master",
          routerKey: "AREAS",
        },
        {
          id: "Categories",
          title: "Categories",
          type: "item",
          url: "/categories-master",
          routerKey: "CATEGORIES",
        },
        {
          id: "Services",
          title: "Services",
          type: "item",
          url: "/services-master",
          routerKey: "SERVICES",
        },
      ],
    },
    {
      id: "ServiceMens",
      title: "Service Mens",
      type: "group",
      url: "/service-mens",
      isIcon: true,
      inactive_icon: InactiveSideBarIcon,
      active_icon: ActiveSideBarIcon,
      isChildren: false,
      // routerKey: 'SERVICEMENS',
    },
    {
      id: "Users",
      title: "Users",
      type: "group",
      url: "/users",
      isIcon: true,
      inactive_icon: InactiveSideBarIcon,
      active_icon: ActiveSideBarIcon,
      isChildren: false,
      // routerKey: 'USERS',
    },
    {
      id: "Bookings",
      title: "Bookings",
      type: "group",
      url: "/bookings",
      isIcon: true,
      inactive_icon: InactiveSideBarIcon,
      active_icon: ActiveSideBarIcon,
      isChildren: false,
      // routerKey: 'BOOKINGS',
    },
    {
      id: "AppMeta",
      title: "App Meta",
      type: "group",
      url: "/app-meta",
      isIcon: true,
      inactive_icon: InactiveSideBarIcon,
      active_icon: ActiveSideBarIcon,
      isChildren: false,
    },
    {
      id: "Settings",
      title: "Settings",
      type: "group",
      url: "/settings",
      isIcon: true,
      inactive_icon: InactiveSideBarIcon,
      active_icon: ActiveSideBarIcon,
      isChildren: false,
    },
    {
      id: "SeeMore",
      title: "See More",
      type: "group",
      isIcon: true,
      inactive_icon: InactiveSideBarIcon,
      active_icon: ActiveSideBarIcon,
      isChildren: true,
      children: [
        // {
        //   id: "Info",
        //   title: "Info",
        //   // type: "group",
        //   isIcon: true,
        //   inactive_icon: InactiveSideBarIcon,
        //   active_icon: ActiveSideBarIcon,
        //   isChildren: true,
        //   children: [
        //     {
        //       id: "AppMeta",
        //       title: "App Meta",
        //       type: "item",
        //       url: "/app-meta",
        //       isSubChildren: false,
        //       // routerKey: 'USER_DISPUTE',
        //     },
        //   ],
        // },
        // {
        //   id: "Restaurant",
        //   title: "Restaurant",
        //   isIcon: true,
        //   inactive_icon: InactiveSideBarIcon,
        //   active_icon: ActiveSideBarIcon,
        //   isChildren: true,
        //   children: [
        //     { title: "Add Restaurant", url: "/add-restaurant" },
        //     { title: "Restaurant List", url: "/restaurant-list" },
        //     { title: "Restaurant Banners", url: "/restaurant-banners" },
        //     { title: "Restaurant Request", url: "/restaurant-request" },
        //     { title: "Request Option", url: "/request-option" },
        //   ],
        // },
        // {
        //   id: "Hotel",
        //   title: "Hotel",
        //   isIcon: true,
        //   inactive_icon: InactiveSideBarIcon,
        //   active_icon: ActiveSideBarIcon,
        //   isChildren: false,
        // },
      ],
      // routerKey: 'DASHBOARD',
    },
  ],

};
